/* Настройки роутера */

import Store       from 'Store'

import Index       from 'components/index'
import LoginForm   from 'components/login-form'
import AdvanceInfo from 'components/advance-info'
import profile     from 'components/profile'
import profileInfo from 'components/profile/info'
import profileEdit from 'components/profile/edit'
import BillList    from 'components/bill-list'
import ZayavkiList     from 'components/zayavki-list'
import AutoImportList     from 'components/auto-import-list'
import AutoImport     from 'components/auto-import'
import CloseStore    from 'components/close-store'
import CntList     from 'components/cnt-list'
import CntPoezd from 'components/cnt-poezd'
import AutoCarrierList from 'components/auto-carrier-list'
import AutoCarrierExpList from 'components/auto-carrier-exp-list'
import AutoExportPoezd from 'components/auto-export-poezd'
import AutoExportCnt from 'components/auto-export-cnt'
import KonosFile from 'components/konos-file'
import StationsList from 'components/stations-list'
import SlotsAuto from 'components/slots-auto'
import OrderTerminal  from 'components/order-terminal'
import OrderNormal  from 'components/order-normal'
import OrderVttKupavna from 'components/order-vtt-kupavna'
import OrderVttHovrino from 'components/order-vtt-hovrino'
import OrderVttZhigsea from 'components/order-vtt-zhigsea'
import OrderUkpEkat from 'components/order-ukp-ekat'
import OrderUkpZhigsea from 'components/order-ukp-zhigsea'
import OrderUkpKleshiha from 'components/order-ukp-kleshiha'
import OrderUkpBazaiha from 'components/order-ukp-bazaiha'
import OrderVttBazaiha from 'components/order-vtt-bazaiha'
import OrderUkpMoscow from 'components/order-ukp-moscow'
import Settings    from 'components/settings'
import Feedback    from 'components/feedback'

var store = new Store('router-config')

export default function (router) {

    router.map({
        '*': {
            component: {
                template: '<h1>404 not found</h1>'
            }
        },
        '/': {
            component: Index,
            name: 'index',
            route: {
                activate(transition) {
                    console.warn(transition)
                }
            },
        },
        '/login': {
            component: LoginForm,
            name: 'login',
        },
        '/logout': {
            component: {
                route: {
                    activate(transition) {
                        store.$set('create_at', 0)
                        store.validate()
                        store.clear()
                        router.go({name: 'login'})
                    }
                },
            },
            name: 'logout',
        },
        '/advance-info': {
            component: AdvanceInfo,
            name: 'advance-info',
        },
        '/profile': {
            component: profile,
            name: 'profile',
            subRoutes: {
                '/info': {
                    component: profileInfo,
                    name: 'profile/info',
                },
                '/edit': {
                    component: profileEdit,
                    name: 'profile/edit',
                },
            },
        },
        '/close-store': {
            component: CloseStore,
            name: 'close-store',
        },
        '/bill-list': {
            component: BillList,
            name: 'bill-list',
        },
        '/zayavki-list': {
            component: ZayavkiList,
            name: 'zayavki-list',
        },
        '/auto-import-list': {
            component: AutoImportList,
            name: 'auto-import-list',
        },
        '/auto-import': {
            component: AutoImport,
            name: 'auto-import',
        },
        '/cnt-list': {
            component: CntList,
            name: 'cnt-list',
        },
        '/cnt-poezd': {
            component: CntPoezd,
            name: 'cnt-poezd',
        },
        '/auto-carrier-list': {
            component: AutoCarrierList,
            name: 'auto-carrier-list',
        },
        '/auto-carrier-exp-list': {
            component: AutoCarrierExpList,
            name: 'auto-carrier-exp-list',
        },
        '/auto-export-poezd': {
            component: AutoExportPoezd,
            name: 'auto-export-poezd',
        },
        '/konos-file': {
            component: KonosFile,
            name: 'konos-file',
        },
        '/auto-export-cnt': {
            component: AutoExportCnt,
            name: 'auto-export-cnt',
        },
        '/stations-list': {
            component: StationsList,
            name: 'stations-list',
        },
        '/slots-auto': {
            component: SlotsAuto,
            name: 'slots-auto',
        },
        '/order-vtt-kupavna': {
            component: OrderVttKupavna,
            name: 'order-vtt-kupavna',
        },
        '/order-vtt-hovrino': {
            component: OrderVttHovrino,
            name: 'order-vtt-hovrino',
        },
        '/order-vtt-zhigsea': {
            component: OrderVttZhigsea,
            name: 'order-vtt-zhigsea',
        },
        '/order-ukp-ekat': {
            component: OrderUkpEkat,
            name: 'order-ukp-ekat',
        },
        '/order-ukp-kleshiha': {
            component: OrderUkpKleshiha,
            name: 'order-ukp-kleshiha',
        },
        '/order-ukp-bazaiha': {
            component: OrderUkpBazaiha,
            name: 'order-ukp-bazaiha',
        },
        '/order-vtt-bazaiha': {
            component: OrderVttBazaiha,
            name: 'order-vtt-bazaiha',
        },
        '/order-ukp-zhigsea': {
            component: OrderUkpZhigsea,
            name: 'order-ukp-zhigsea',
        },
        '/order-ukp-moscow': {
            component: OrderUkpMoscow,
            name: 'order-ukp-moscow',
        },
        '/order-terminal': {
            component: OrderTerminal,
            name: 'order-terminal',
        },
        '/order-normal': {
            component: OrderNormal,
            name: 'order-normal',
        },
        '/settings': {
            component: Settings,
            name: 'settings',
        },
        '/feedback': {
            component: Feedback,
            name: 'feedback',
        },
    })

    router.alias({
        '/index': '/',
    })

    router.redirect({
        '/profile': '/profile/info',
    })

    router.beforeEach(({abort, from, next, redirect, to}) => {
        // если не авторизованы, то форма авторизации
        if (!store.$get('auth')) {
            router.go({name: 'login'})
            // если авторизованы, то редирект с формы авторизации
        } else if (to.name === 'login') {
            // страница по умолчанию
            router.go({name: 'index'})
        }
        next()
    })
 router.afterEach(({from, to})=>{
        if (from.name === 'logout' && to.name === 'login'){
            location.reload();    /*Reload page to reset vue app*/
        }
    })
    return router
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/route-config.js
 **/